import React from 'react'

import BotSimpleMessage from './BotSimpleMessage'

import { MzInputText } from '../../components';

import { Button } from 'primereact/button';

import UserMessage from '../UserMessage';

import ApiUtils from "../../api/ApiUtils"

import Functions from '../utils/Functions';

export default function ChatComponent({ message, isLastBotMessage, setMessages, setIsTyping, messages, urlBotImage }) {
    const [loading, setLoading] = React.useState(false);
    const [buttonDisabled, setButtonDisabled] = React.useState(!isLastBotMessage);
    const [inputValue, setInputValue] = React.useState(message.inputValue || "");

    const onClick = async () => {
        console.log("Button clicked with input:", inputValue);
        let domanda = inputValue;

        let body = {
            "payload": message.payload,
            "msg": domanda
        };

        setLoading(true);
        let resp = await ApiUtils.post("tariff_comparator/v1/chat", body);

        let chatMsg = {
            "id": resp.data.id,
            "tipo": "chat",
            "sender": "bot",
            "testo": resp.data.answer,
            "payload": resp.data.payload
        };
        setLoading(false);
        setButtonDisabled(true);
        Functions.addMetaInfo(chatMsg);
        console.log("New message added:", chatMsg);

        // Aggiorna il messaggio corrente con il valore dell'input
        const updatedMessages = messages.map((msg) => {
            if (msg.id === message.id) {
                return { ...msg, inputValue: inputValue };
            }
            return msg;
        });

        setMessages([...updatedMessages, chatMsg]);
    };



    return (
        <>
            <BotSimpleMessage key={"bot1_" + message.id} urlBotImage={urlBotImage} message={message} isLastBotMessage={isLastBotMessage} setMessages={setMessages} setIsTyping={setIsTyping} messages={messages} />
            {buttonDisabled == false ?
                <div className="grid">
                    <div className='col-9 col-offset-1'>
                        <MzInputText
                            placeholder="Scrivi qui la tua domanda"
                            className="ml-2 w-full"
                            id={"input_" + message.id}
                            stateValue={inputValue}
                            setStateValue={setInputValue}
                            disabled={buttonDisabled}
                        />
                    </div>
                    <div className='col-2 '>
                        <Button loading={loading} disabled={buttonDisabled} onClick={onClick} className='ml-2' label={loading ? "" : ">"} />
                    </div>
                </div>
                : <UserMessage msg={message}></UserMessage>
            }
        </>
    );
}





